import React, { FC } from 'react';
import EventCharts, { EventCharts as EventChartsInnerComponent } from '@components/machines/components/eventsChart';
import { useJobDetails } from '@v2/pages/common/hooks/useJobDetails';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { connect } from 'react-redux';
import { updateHeaderConfig } from '@reducers/details';
import { getProductionBatchByProductionOperationId, operationsSearch } from '@reducers/search';
import { getNCFilesByProductionOperationId } from '@reducers/manufacture';
import JobContentWrapper from '@v2/pages/job/common/components/JobContentWrapper';

interface JobDetailsNCFilePerformanceActiveProps {}

const JobDetailsNCFilePerformanceActiveComponent: FC<JobDetailsNCFilePerformanceActiveProps> = ({
  updateHeaderConfig,
  operationsSearch,
  getNCFilesByProductionOperationId,
  getProductionBatchByProductionOperationId,
}) => {
  const title = useTitle();

  useJobDetails({
    updateHeaderConfig,
    operationsSearch,
    getNCFilesByProductionOperationId,
    getProductionBatchByProductionOperationId,
    getAllNcFiles: true,
  });

  return (
    <JobContentWrapper loading={false} title={title.ncFile}>
      <EventCharts getContentElement={(props) => <EventChartsInnerComponent {...props} />} />
    </JobContentWrapper>
  );
};

const JobDetailsNCFilePerformanceActive = connect(null, {
  updateHeaderConfig,
  operationsSearch,
  getNCFilesByProductionOperationId,
  getProductionBatchByProductionOperationId,
})(JobDetailsNCFilePerformanceActiveComponent);

export { JobDetailsNCFilePerformanceActive };
